import React from 'react';
import moment from 'moment';
import styles from './previewTemplateContent.module.scss';

const BroadcastTemplatePreview = (props) => {
  console.log(props);
  const { broadcastPreview } = props;

  const onSetStyle = (children) => {
    return (
      <div
        className={styles.showAddText}
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          fontSize: children.textSize,
          color: children.textColor,
          fontWeight: children.textTags.indexOf('粗體') >= 0 ? '900' : 'normal',
          fontStyle:
            children.textTags.indexOf('斜體') >= 0 ? 'italic' : 'normal',
          justifyContent: children.textLevel,
          alignItems:
            (children.textVertical === 'start' && 'flex-start') ||
            (children.textVertical === 'center' && 'center') ||
            (children.textVertical === 'end' && 'flex-end'),
          backgroundImage:
            (children.typeContent === 'image' &&
              `url(${children.typeFormat})`) ||
            'none',
          backgroundSize:
            (children.textSize === 'fullVersion' && 'cover') ||
            (children.textSize === 'originalSize' && 'Contain') ||
            (children.textSize === 'repeat' && 'Contain'),
          backgroundRepeat:
            children.textSize === 'repeat' ? 'repeat' : 'no-repeat',
          backgroundPosition: children.textLevel,
        }}
      >
        {(children.typeContent === 'date' ||
          children.typeContent === 'time' ||
          children.typeContent === 'dateTime') &&
          moment(new Date()).format(children.typeFormat)}
        {children.typeContent === 'text' &&
          children.typeFormat.split('\n').map((i) => (
            <>
              {i}
              <br />
            </>
          ))}
        {children.typeContent === 'weather' && `${children.typeFormat}天氣`}
        {children.typeContent === '空氣品質' && (
          <div className={styles.immediate}>
            <div>室外PM₁.₀</div>
            <div>室外PM₂.₅</div>
            <div>室外PM₁₀</div>
            <div>室內PM₂.₅</div>
            <div>室內PM₁₀</div>
            <div>室內CO₂</div>
            <div>室內TVOC</div>
            <div>室內CH₂O</div>
          </div>
        )}
        {children.typeContent === '照度' && '室內照度'}
        {children.typeContent === '濕度' && '室內濕度'}
        {children.typeContent === '溫度' && '室內溫度'}
      </div>
    );
  };

  if (broadcastPreview.template === 'one') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          {broadcastPreview.content.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  width: `${item.size}%`,
                  backgroundColor: item.color,
                  height: '100%',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (broadcastPreview.template === 'two') {
    return (
      <div className={styles.container}>
        <div className={styles.templateTop}>
          {broadcastPreview.content.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.templateTwo}
                style={{
                  width: `${item.size}%`,
                  backgroundColor: item.color,
                  height: '100%',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (broadcastPreview.template === 'three') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          {broadcastPreview.content.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.templateTwo}
                style={{
                  height: `${item.size}%`,
                  backgroundColor: item.color,
                  width: '100%',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (broadcastPreview.template === 'four') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent} style={{ border: 0 }}>
          <div
            className={styles.templateTop}
            style={{
              height: `${100 - broadcastPreview.content[2].size}%`,
              width: '100%',
              border: 0,
            }}
          >
            {broadcastPreview.content.map((item, index) => {
              if (index !== 2) {
                return (
                  <div
                    key={index}
                    className={styles.templateTwo}
                    style={{
                      width: `${item.size}%`,
                      backgroundColor: item.color,
                      height: '100%',
                    }}
                  >
                    {item.children.length > 0
                      ? onSetStyle(item.children[0])
                      : '未設定內容'}
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
          <div
            className={styles.templateBottom}
            style={{ height: `${broadcastPreview.content[2].size}%` }}
          >
            <div
              key={2}
              className={styles.templateTwo}
              style={{
                width: '100%',
                backgroundColor: broadcastPreview.content[2].color,
                height: '100%',
              }}
            >
              {broadcastPreview.content[2].children.length > 0
                ? onSetStyle(broadcastPreview.content[2].children[0])
                : '未設定內容'}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default BroadcastTemplatePreview;
